<template>
  <div class="query">
    <input
      type="text"
      v-model="query"
      class="query__input"
      :placeholder="$t('favourites.placeholder')"
    />
    <div class="query__icon">
      <Icon :small="true">
        <img src="@/assets/query.png" alt="" />
      </Icon>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/icon';

export default {
  name: 'favourites-query',
  components: { Icon },
  computed: {
    query: {
      get() {
        return this.$store.state.favouritesQuery;
      },
      set(value) {
        this.$store.commit('FIND_IN_FAVOURITES', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.query {
  display: flex;

  width: 100%;

  border-bottom: 1px solid $lightGray;
  padding-bottom: 2px;
}

.query__input {
  flex: 1;

  font-size: 12px;

  background: none;
  border: none;

  &::placeholder {
    color: $gray;
  }

  &:focus {
    outline: none;
  }
}
</style>
